import { useTranslation } from 'react-i18next';
import { StatusBadge } from '../StatusBadge';

/**
 * SP-8 follow-up — badge "Parziale" mostrato nella tabella lista pick-list
 * quando la lista ha `partials_count > 0` e lo status è `fulfilled` o
 * `confirmed`. Gemello di [PickListPendingSplitBadge]: stesso pattern
 * (StatusBadge tone + label i18n), tono `warn` (giallo) — il rosso era
 * stato giudicato troppo aggressivo (rollback richiesto dall'utente).
 *
 * Il tooltip contiene il count esatto delle righe inevase (`count` prop).
 */
export function PickListPartialBadge({ count }: { count: number }) {
  const { t } = useTranslation('picklist');
  return (
    <span title={t('partial_badge.tooltip', { count })}>
      <StatusBadge tone="warn">
        <i className="bi bi-exclamation-triangle-fill me-1" />
        {t('partial_badge.label')}
      </StatusBadge>
    </span>
  );
}
